module.exports = __webpack_public_path__ + "onboarding-environments.f9920c6e1979e3aae8e917842cec9cd6.hashedasset.svg";


//////////////////
// WEBPACK FOOTER
// ./app/img/environments/empty/onboarding-environments.svg
// module id = 7420618717243896
// module chunks = 1